import { render, staticRenderFns } from "./cleaning.vue?vue&type=template&id=52e35271&scoped=true&"
import script from "./cleaning.vue?vue&type=script&lang=js&"
export * from "./cleaning.vue?vue&type=script&lang=js&"
import style0 from "./cleaning.vue?vue&type=style&index=0&id=52e35271&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e35271",
  null
  
)

export default component.exports